import React from 'react'

import { bool, string, element } from 'prop-types'
import { css } from '@emotion/react'
import { Button } from '@livechat/design-system-react-components'

export const installedCss = (theme) => css`
  background-color: transparent;
  color: ${theme.colors.black};
  border-color: ${theme.colors.black};
  pointer-events: none;
`

export const ActivatedButton = ({
  className,
  fullWidth,
  size,
  icon,
  negative,
}) => {
  const type = negative ? 'installed-negative' : 'installed'

  return (
    <Button
      type={type}
      size={size}
      icon={icon || ''}
      disabled
      css={installedCss}
      className={className}
      fullWidth={fullWidth}
    >
      Activated
    </Button>
  )
}

ActivatedButton.propTypes = {
  className: string,
  fullWidth: bool,
  size: string,
  negative: bool,
  icon: element,
}

export default ActivatedButton
